import { LearningActivity } from '../types';
import { ApplicationUser } from '../../hooks/auth/useAuth';
import { DEFAULT_COURSE_CONDITION, FeatureFlagsCondition, getCourseConditionFromLearningActivity, getUserConditions } from './conditions';
import { Condition, RuleResult } from './types';
import { applyRules } from './actionButtonResolver';
import { queryRegistrationRules } from './rules';

export function shouldQueryRegistrationCounter(
    learningActivity: LearningActivity | undefined,
    user: ApplicationUser | undefined,
    features: FeatureFlagsCondition,
) {
    if (!learningActivity || !user) {
        return false;
    }
    const condition: Condition = {
        courseCondition: getCourseConditionFromLearningActivity(learningActivity) ?? DEFAULT_COURSE_CONDITION,
        userCondition: getUserConditions(user),
        featureFlagsCondition: features,
    };
    const result = applyRules(queryRegistrationRules, condition);

    return result === RuleResult.ALLOW;
}
